import React, { useState } from 'react';
import ImportData from './ImportData';
import CategoryInventorySetup from './CategoryInventorySetup';
import { Upload, Calculator, ListTree, ShoppingBag } from 'lucide-react';

const SareeSetup = () => {
  const [tab, setTab] = useState('import'); // 'import' | 'setup' | 'calculator'

  const tabs = [
    { key: 'import', label: 'Bulk Import', icon: <Upload size={16} /> },
    { key: 'setup', label: 'Inventory Setup', icon: <ListTree size={16} /> },
    { key: 'calculator', label: 'Price Calculator', icon: <Calculator size={16} /> }
  ];

  return (
    <div className="fade-in">
      {/* --- ট্যাব সুইচার --- */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '30px', maxWidth: '650px', margin: '0 auto 30px' }}>
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              flex: 1, padding: '14px', borderRadius: '15px', border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              background: tab === t.key ? 'linear-gradient(45deg, #4a00e0, #8e2de2)' : '#eef1fb',
              color: tab === t.key ? 'white' : '#666', transition: '0.2s'
            }}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab === 'import' && <ImportData />}
      {tab === 'setup' && <CategoryInventorySetup />}
      {tab === 'calculator' && <SareePriceCalculator />}
    </div>
  );
};

// জাভাস্ক্রিপ্ট floating-point রাউন্ডিং সমস্যা (যেমন 36.55 -> 36.549999...) এড়ানোর জন্য
const roundFix = (num, decimals = 1) => {
  const factor = Math.pow(10, decimals);
  return Math.round((num + Number.EPSILON * 1e6) * factor) / factor;
};

// --- শাড়ির দাম নির্ধারণ ক্যালকুলেটর ---
const SareePriceCalculator = () => {
  const [mode, setMode] = useState('bulk'); // 'single' | 'bulk'

  const [buyingPrice, setBuyingPrice] = useState('');   // single mode: unit price
  const [totalBuyingPrice, setTotalBuyingPrice] = useState(''); // bulk mode: total price
  const [quantity, setQuantity] = useState('1');
  const [otherCost, setOtherCost] = useState('');        // total other cost (transport+food etc.)
  const [marginPercent, setMarginPercent] = useState('30');
  const [manualPrice, setManualPrice] = useState('');

  const qtyNum = Math.max(1, parseFloat(quantity) || 1);
  const otherNum = parseFloat(otherCost) || 0;
  const marginNum = parseFloat(marginPercent) || 0;
  const manualNum = parseFloat(manualPrice) || 0;

  // প্রতি পিসের মোট খরচ হিসাব
  let unitCost = 0;
  if (mode === 'single') {
    const buyNum = parseFloat(buyingPrice) || 0;
    unitCost = buyNum + otherNum; // single mode-এ other cost সরাসরি এক পিসের জন্য ধরা হয়
  } else {
    const totalBuyNum = parseFloat(totalBuyingPrice) || 0;
    unitCost = (totalBuyNum + otherNum) / qtyNum; // বাল্ক মোডে সব খরচ পিস সংখ্যা দিয়ে ভাগ হয়
  }

  const marginValid = marginNum > 0 && marginNum < 100;
  const suggestedPriceRaw = marginValid ? (unitCost / (1 - marginNum / 100)) : 0;
  const suggestedProfitRaw = suggestedPriceRaw - unitCost;
  const suggestedPrice = roundFix(suggestedPriceRaw, 0);
  const suggestedProfit = roundFix(suggestedProfitRaw, 0);

  const hasValidInput = unitCost > 0 && marginValid;

  const manualProfitRaw = manualNum - unitCost;
  const manualMarginRaw = manualNum > 0 ? (manualProfitRaw / manualNum) * 100 : 0;
  const manualProfit = roundFix(manualProfitRaw, 0);
  const manualMargin = roundFix(manualMarginRaw, 1);
  const showManual = manualNum > 0 && unitCost > 0;

  return (
    <div style={{ maxWidth: '1150px', margin: '0 auto' }}>

      <div style={{ textAlign: 'center', marginBottom: '25px' }}>
        <h2 style={{ marginBottom: '8px' }}>🧮 Saree Price Calculator</h2>
        <p style={{ color: '#888', fontSize: '14px' }}>
          Enter the buying price, other costs, and desired profit margin — the right selling price will come out.
        </p>
      </div>

      {/* --- দুই কলাম লেআউট: বাম দিকে ইনপুট, ডান দিকে রেজাল্ট --- */}
      <div style={{ display: 'flex', gap: '25px', alignItems: 'flex-start', flexWrap: 'wrap' }}>

        {/* বাম কলাম: ইনপুট ফর্ম */}
        <div className="white-box" style={{ border: '2px dashed #5100e1', flex: '1 1 480px', minWidth: '380px' }}>

          {/* একক / বাল্ক মোড টগল */}
          <div style={{ display: 'flex', gap: '10px', marginBottom: '25px', justifyContent: 'center' }}>
            <button
              onClick={() => setMode('single')}
              style={{
                padding: '8px 18px', borderRadius: '20px', border: 'none', cursor: 'pointer',
                fontWeight: 600, fontSize: '13px',
                background: mode === 'single' ? '#5100e1' : '#f4f7fe',
                color: mode === 'single' ? 'white' : '#666'
              }}
            >
              Single Saree
            </button>
            <button
              onClick={() => setMode('bulk')}
              style={{
                padding: '8px 18px', borderRadius: '20px', border: 'none', cursor: 'pointer',
                fontWeight: 600, fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px',
                background: mode === 'bulk' ? '#5100e1' : '#f4f7fe',
                color: mode === 'bulk' ? 'white' : '#666'
              }}
            >
              <ShoppingBag size={14} /> Multiple at Once (Bulk)
            </button>
          </div>

          <p style={{ color: '#a3aed0', fontSize: '11px', letterSpacing: '1px', marginBottom: '15px', textAlign: 'center', textTransform: 'uppercase' }}>
            Saree Cost Details
          </p>

          {mode === 'single' ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                  Buying Price (1 pcs)
                </label>
                <input type="number" onWheel={(e) => e.target.blur()} min="0" className="input-field" placeholder="৳ 1000"
                  value={buyingPrice} onChange={e => setBuyingPrice(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                  Other Cost (for this piece)
                </label>
                <input type="number" onWheel={(e) => e.target.blur()} min="0" className="input-field" placeholder="৳ 50"
                  value={otherCost} onChange={e => setOtherCost(e.target.value)} />
              </div>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                  Total Buying Price (all pieces combined)
                </label>
                <input type="number" onWheel={(e) => e.target.blur()} min="0" className="input-field" placeholder="৳ 10000 (e.g. Jamdani 10 pcs)"
                  value={totalBuyingPrice} onChange={e => setTotalBuyingPrice(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                  Piece Count (Quantity)
                </label>
                <input type="number" onWheel={(e) => e.target.blur()} min="1" className="input-field" placeholder="10"
                  value={quantity} onChange={e => setQuantity(e.target.value)} />
              </div>
              <div style={{ gridColumn: '1 / span 2' }}>
                <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                  Total Other Cost (transport + food + anything else — combined)
                </label>
                <input type="number" onWheel={(e) => e.target.blur()} min="0" className="input-field" placeholder="৳ 750 (e.g. transport 500 + food 250)"
                  value={otherCost} onChange={e => setOtherCost(e.target.value)} />
              </div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '5px' }}>
            <div>
              <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                Desired Profit Margin (%)
              </label>
              <input type="number" onWheel={(e) => e.target.blur()} min="0" max="99" className="input-field" placeholder="30"
                value={marginPercent} onChange={e => setMarginPercent(e.target.value)} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px' }}>
                Total Cost per Piece (auto)
              </label>
              <div className="input-field" style={{ background: '#f4f7fe', color: '#5100e1', fontWeight: 700 }}>
                ৳ {unitCost.toFixed(0)}
              </div>
            </div>
          </div>

          {mode === 'bulk' && qtyNum > 0 && (
            <p style={{ fontSize: '12px', color: '#a3aed0', marginTop: '12px', textAlign: 'center' }}>
              Calculation: (Total buying price + total other cost) ÷ {qtyNum} pcs = ৳ {unitCost.toFixed(0)} per piece
            </p>
          )}

          {/* উল্টোভাবে যাচাই — বাম কলামের নিচেই যুক্ত করা হয়েছে */}
          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px dashed #e0e5f2', textAlign: 'center' }}>
            <p style={{ color: '#a3aed0', fontSize: '11px', letterSpacing: '1px', marginBottom: '12px', textTransform: 'uppercase' }}>
              Or, enter your own price to check
            </p>
            <div style={{ maxWidth: '280px', margin: '0 auto' }}>
              <input type="number" onWheel={(e) => e.target.blur()} min="0" className="input-field" placeholder="৳ 2000" style={{ marginBottom: showManual ? '10px' : 0 }}
                value={manualPrice} onChange={e => setManualPrice(e.target.value)} />
            </div>

            {showManual && (
              <div style={{
                padding: '12px', borderRadius: '15px', maxWidth: '400px', margin: '0 auto',
                background: manualProfit >= 0 ? '#eafff3' : '#fff0f0',
                border: `1px solid ${manualProfit >= 0 ? '#32d391' : '#ee5253'}`
              }}>
                <p style={{ margin: 0, fontSize: '14px', color: manualProfit >= 0 ? '#218c61' : '#ee5253', fontWeight: 600 }}>
                  Profit at this price: ৳ {manualProfit.toFixed(0)} &nbsp;•&nbsp; Margin: {manualMargin.toFixed(1)}%
                </p>
                {manualProfit < 0 && (
                  <p style={{ margin: '5px 0 0 0', fontSize: '13px', color: '#ee5253' }}>
                    ⚠️ Selling at this price will result in a loss!
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ডান কলাম: রেজাল্ট কার্ড */}
        <div style={{ flex: '1 1 300px', minWidth: '260px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="stat-card green-g" style={{ textAlign: 'left', borderRadius: '25px' }}>
            <h4 style={{ margin: '0 0 8px 0' }}>Suggested Selling Price</h4>
            <p style={{ fontSize: '32px', margin: '5px 0' }}>
              {hasValidInput ? `৳ ${suggestedPrice.toFixed(0)}` : '—'}
            </p>
            <p style={{ fontSize: '12px', opacity: 0.85, fontWeight: 400 }}>
              Selling each piece at this price meets your target profit margin
            </p>
          </div>

          <div className="stat-card orange-g" style={{ textAlign: 'left', borderRadius: '25px' }}>
            <h4 style={{ margin: '0 0 8px 0' }}>Profit per Piece</h4>
            <p style={{ fontSize: '32px', margin: '5px 0' }}>
              {hasValidInput ? `৳ ${suggestedProfit.toFixed(0)}` : '—'}
            </p>
            <p style={{ fontSize: '12px', opacity: 0.85, fontWeight: 400 }}>
              Net profit per saree after all costs
            </p>
          </div>

          {mode === 'bulk' && hasValidInput && qtyNum > 0 && (
            <div className="stat-card blue-g" style={{ textAlign: 'left', borderRadius: '25px' }}>
              <h4 style={{ margin: '0 0 8px 0' }}>Total Potential Profit ({qtyNum} pcs)</h4>
              <p style={{ fontSize: '32px', margin: '5px 0' }}>
                ৳ {(suggestedProfit * qtyNum).toFixed(0)}
              </p>
              <p style={{ fontSize: '12px', opacity: 0.85, fontWeight: 400 }}>
                Total profit if the whole lot sells
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SareeSetup;